export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/3d_procgen/triplanar_sharpening": [2],
		"/depth_based_fragment_culling/depth_diffuse": [3],
		"/depth_based_fragment_culling/tiling_compare": [4],
		"/smooth_procedural_meshes/delta_t_penalty_comparison_normal": [5],
		"/smooth_procedural_meshes/delta_t_penalty_comparison_wireframe": [6],
		"/subdivide/blender_artifacts_example": [7],
		"/subdivide/bouncy_house": [8],
		"/subdivide/edge_normals": [9],
		"/subdivide/naive_displacement_demo": [10],
		"/subdivide/noise_displ": [11],
		"/subdivide/pre_sharp_edges": [12],
		"/subdivide/smooth_flat_shading": [13],
		"/tech_behind_geotoy/na8o_comparison": [14],
		"/triplanar_mapping_enhancement": [15]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';